export default class Account {
    constructor(Rest) {
        this.rest = Rest.rest;
    }
    
    me() {
        return this.rest.one('account/me').get();
    };

    getRemainingSendCount() {
        return this.rest.one('account/remainingSendCount').get();
    };

    getRemainingSubscriberCount() {
        return this.rest.one('account/remainingSubscriberCount').get();
    };

    getAvailableAccounts() {
        return this.rest.one('account/availableAccounts').get();
    };

    toggleSoftLimit() {
        return this.rest.one('account/softLimit').post();
    };

    registerCustomIdentifier(fieldId) {
        return this.rest.all('account/custom-identifier').post({ field_id: fieldId });
    };

    clearCustomIdentifier() {
        return this.rest.all('account/custom-identifier').remove();
    };
};

Account.$inject = ['Rest'];